import React from "react";

const NotFound = () => {
	return <div>404</div>;
};

export default NotFound;



// WEBPACK FOOTER //
// ./src/NotFound.js